/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
// @ts-ignore
import type * as Types from '../../../../../packages/graphql/index';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type OrderRecommendationsQueryVariables = Exact<{
  buyingCompanyId: string;
}>;


export type OrderRecommendationsQuery = { getOrderRecommendations: { recommendations: Array<{ contractReferenceId: string, id: string, orderReferenceId: string, orderCreatedAt: string, totalPriceExlTax: number } | null> } | null };


export const OrderRecommendationsDocument = /*#__PURE__*/ gql`
    query OrderRecommendations($buyingCompanyId: uuid!) {
  getOrderRecommendations(buyingCompanyId: $buyingCompanyId) {
    recommendations {
      contractReferenceId
      id
      orderReferenceId
      orderCreatedAt
      totalPriceExlTax
    }
  }
}
    `;

/**
 * __useOrderRecommendationsQuery__
 *
 * To run a query within a React component, call `useOrderRecommendationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrderRecommendationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrderRecommendationsQuery({
 *   variables: {
 *      buyingCompanyId: // value for 'buyingCompanyId'
 *   },
 * });
 */
export function useOrderRecommendationsQuery(baseOptions: Apollo.QueryHookOptions<OrderRecommendationsQuery, OrderRecommendationsQueryVariables> & ({ variables: OrderRecommendationsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrderRecommendationsQuery, OrderRecommendationsQueryVariables>(OrderRecommendationsDocument, options);
      }
export function useOrderRecommendationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrderRecommendationsQuery, OrderRecommendationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrderRecommendationsQuery, OrderRecommendationsQueryVariables>(OrderRecommendationsDocument, options);
        }
// @ts-ignore
export function useOrderRecommendationsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<OrderRecommendationsQuery, OrderRecommendationsQueryVariables>): Apollo.UseSuspenseQueryResult<OrderRecommendationsQuery, OrderRecommendationsQueryVariables>;
export function useOrderRecommendationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OrderRecommendationsQuery, OrderRecommendationsQueryVariables>): Apollo.UseSuspenseQueryResult<OrderRecommendationsQuery | undefined, OrderRecommendationsQueryVariables>;
export function useOrderRecommendationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OrderRecommendationsQuery, OrderRecommendationsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<OrderRecommendationsQuery, OrderRecommendationsQueryVariables>(OrderRecommendationsDocument, options);
        }
export type OrderRecommendationsQueryHookResult = ReturnType<typeof useOrderRecommendationsQuery>;
export type OrderRecommendationsLazyQueryHookResult = ReturnType<typeof useOrderRecommendationsLazyQuery>;
export type OrderRecommendationsSuspenseQueryHookResult = ReturnType<typeof useOrderRecommendationsSuspenseQuery>;
export type OrderRecommendationsQueryResult = Apollo.QueryResult<OrderRecommendationsQuery, OrderRecommendationsQueryVariables>;